export const mainNavigation = [
  { label: 'Home', path: '/' },
  { label: 'Software', path: '/software' },
  { label: 'Technology', path: '/technology' },
  { label: 'Engineering', path: '/engineering' },
  { label: 'Investors', path: '/investors' },
  { label: 'About', path: '/about' },
  { label: 'Careers', path: '/careers' },
  { label: 'Shop', path: '/shop' },
  { label: 'Contact', path: '/contact' },
]

export const routes = [
  { path: '/software/developer', label: 'Developer', title: 'Libraries and APIs for technical teams.' },
  { path: '/careers', label: 'Careers', title: 'Work on problems that matter.' },
  { path: '/contact', label: 'Contact', title: 'Start a conversation with Aldapa Systems.' },
  { path: '/account/create', label: 'Account', title: 'Create your Aldapa Systems account.' },
  { path: '/docs', label: 'Documentation', title: 'Technical documentation and resources.' },
  { path: '/docs/aldapanucore', label: 'Documentation', title: 'AldapaNuCore documentation.' },
  { path: '/docs/nuspectra', label: 'Documentation', title: 'NuSpectra documentation.' },
  { path: '/docs/numath', label: 'Documentation', title: 'NuMath documentation.' },
  { path: '/legal/privacy', label: 'Legal', title: 'Privacy.' },
  { path: '/legal/terms', label: 'Legal', title: 'Terms.' },
  { path: '/legal/security', label: 'Legal', title: 'Security.' },
]
